/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { popupcontext } from "../../../../context/Popupscontext";
/*import {
	useGetAllDevicesQuery,
	useLazyGetUsersDeviceQuery,
} from "../../../../Redux/service/Devices";*/
//import { filtrationcontext } from "../../../../context/Filtercontext";
import { useMap } from "react-leaflet";
import { useLocation } from "react-router-dom";
import { useGetUsersGeofencesQuery } from "../../../../Redux/service/Geofences/Geofences";
import { useSelector } from "react-redux";
import { useLazyGetSpecificPositionQuery } from "../../../../Redux/service/Positions";
import trans from "../../../../utils";
import { filtrationcontext } from "../../../../context/Filtercontext";
import { Segmented } from "antd";

export default function ObjectHead({ setType, type }) {
	const map = useMap();
	let inf = useSelector((state) => state.users.user);
	let { handleClose, setObjectselect } = useContext(popupcontext);
	let { setTrackingType } = useContext(filtrationcontext);
	/*const [offlineCount, setOfflineCount] = useState(0);
	const [onlineCount, setOnlineCount] = useState(0);
	const [unknownCount, setUnknownCount] = useState(0);
	const [idleCount, setIdleCount] = useState(0);
	const [movingCount, setMovingCount] = useState(0);
	const {
		parentCheck,
		childCheck,
		setOnlineVehicles,
		setOfflineVehicles,
		setUnkownVehicles,
		setMovingVehicles,
		setIdleVehicles,
		isFilterTriggered,
		filter,
		setSort,
	} = useContext(filtrationcontext);*/
	//const positions = useSelector((state) => state.webSocket.positions);

	//const [getUsersDevice] = useLazyGetUsersDeviceQuery();
	useLazyGetSpecificPositionQuery();
	//const { data: allDevices } = useGetAllDevicesQuery();
	const { data: Geofences } = useGetUsersGeofencesQuery(inf.id, {
		skip: !inf.id,
	});
	let { pathname } = useLocation();
	const handleClick = () => {
		handleClose("object");
		setObjectselect(false);
		map.dragging.enable();
	};

	/*useEffect(() => {
		const fetchDataForIds = async () => {
			let offline = 0;
			let online = 0;
			let unknown = 0;
			let idle = 0;
			let moving = 0;
	
			const ids = [...parentCheck, ...childCheck];
			const promises = ids.map(async (id) => {
				try {
					const devices = await getUsersDevice(id).unwrap();
					const devicePromises = devices.map(async (device) => {
						const devicePositions = positions?.filter(
							(pos) => pos.deviceId === device.id
						);
						if (device.status === "offline") offline++;
	
						try {
							devicePositions?.forEach((i) => {
								if (device.status === "unknown") unknown++;
								else if (device.status === "online") {
									online++;
									if (i.attributes.motion === false) idle++;
									else if (i.attributes.motion === true) moving++;
								}
							});
						} catch (err) {
							console.error(`Error in position loop`, err);
						}
					});
					await Promise.all(devicePromises);
				} catch (err) {
					console.error(`Error in device fetch`, err);
				}
			});
			await Promise.all(promises);
	
			updateCounts({ offline, online, unknown, idle, moving });
		};
	
		const updateCounts = ({ offline, online, unknown, idle, moving }) => {
			// Only update if counts actually changed
			setOfflineCount((prev) => (prev !== offline ? offline : prev));
			setOnlineCount((prev) => (prev !== online ? online : prev));
			setUnknownCount((prev) => (prev !== unknown ? unknown : prev));
			setIdleCount((prev) => (prev !== idle ? idle : prev));
			setMovingCount((prev) => (prev !== moving ? moving : prev));
		};
	
		if ((parentCheck.length || childCheck.length) && isFilterTriggered) {
			fetchDataForIds();
		} else if (allDevices && positions?.length) {
			let offline = 0;
			let online = 0;
			let unknown = 0;
			let idle = 0;
			let moving = 0;
	
			allDevices?.forEach((device) => {
				const devicePositions = positions?.filter(
					(pos) => pos.deviceId === device.id
				);
				if (device.status === "offline") offline++;
				else if (device.status === "unknown") unknown++;
				else if (device.status === "online") {
					online++;
					devicePositions?.forEach((pos) => {
						if (pos.attributes.motion === false) idle++;
						else if (pos.attributes.motion === true) moving++;
					});
				}
			});
	
			if (!filter) {
				updateCounts({ offline, online, unknown, idle, moving });
			}
		}
	}, [
		parentCheck,
		childCheck,
		allDevices,
		getUsersDevice,
		isFilterTriggered,
		positions,
		filter,
	]);*/

	const lang = localStorage.getItem("lang") || "en";

	return (
		<>
			<div className="flex-between p-8-10 my-8">
				{pathname === "/livetracking" ? (
					<div className="d-flex">
						<Segmented
							options={[
								{ label: trans("Vehicles"), value: "vehicle" },
								{ label: trans("Mobility"), value: "mobility" },
							]}
							checked={type}
							value={type}
							onChange={(e) => {
								setType(e);
								setTrackingType(e);
								setObjectselect(false);
							}}
							width={100}
						/>
						{/* <div className={`fs-16 fw-600 ${lang === "en" ? "me-2" : "ms-2"}`}>
							{trans("Vehicles")}
						</div> */}
						{/**		<div
							className="object-details-head object-head-first"
							onClick={() => {
								setOfflineVehicles(false);
								setOnlineVehicles(false);
								setUnkownVehicles(false);
								setIdleVehicles(false);
								setMovingVehicles(false);
								setSort({ type: "last update", value: false });
							}}
						>
							{lang === "ar" && (
								<span className="text-capitalize ms-1" title={trans("total")}>
									المجموع
								</span>
							)}
							{(parentCheck.length > 0 || childCheck.length > 0) && filter
								? offlineCount + onlineCount + unknownCount
								: allDevices?.length || 0}
							{lang !== "ar" && (
								<span className="text-capitalize me-1" title={trans("total")}>
									Total
								</span>
							)}
						</div>
						<div
							className="object-details-head object-head-second"
							onClick={() => {
								setOnlineVehicles(true);
								setSort({ type: null, value: null });
								setOfflineVehicles(false);
								setUnkownVehicles(false);
								setIdleVehicles(false);
								setMovingVehicles(false);
							}}
							title={trans("online")}
						>
							{onlineCount ? onlineCount : 0}
						</div>
						<div
							className="object-details-head object-head-third"
							onClick={() => {
								setOfflineVehicles(true);
								setSort({ type: null, value: null });
								setOnlineVehicles(false);
								setUnkownVehicles(false);
								setIdleVehicles(false);
								setMovingVehicles(false);
							}}
							title={trans("offline")}
						>
							{offlineCount ? offlineCount : 0}
						</div>
						<div
							className="object-details-head object-head-fourth"
							onClick={() => {
								setUnkownVehicles(true);
								setSort({ type: null, value: null });
								setIdleVehicles(false);
								setMovingVehicles(false);
								setOfflineVehicles(false);
								setOnlineVehicles(false);
							}}
							title={trans("unknown")}
						>
							{unknownCount ? unknownCount : 0}
						</div>
						<div
							className="object-details-head object-head-fifth"
							onClick={() => {
								setIdleVehicles(true);
								setMovingVehicles(false);
								setSort({ type: null, value: null });
								setOfflineVehicles(false);
								setOnlineVehicles(false);
								setUnkownVehicles(false);
							}}
							title={trans("idle")}
						>
							{idleCount ? idleCount : 0}
						</div>
						<div
							className="object-details-head object-head-sixth"
							onClick={() => {
								setMovingVehicles(true);
								setSort({ type: null, value: null });
								setOfflineVehicles(false);
								setOnlineVehicles(false);
								setIdleVehicles(false);
								setUnkownVehicles(false);
							}}
							title={trans("moving")}
						>
							{movingCount ? movingCount : 0}
						</div>*/}
					</div>
				) : (
					<div className="w-233 d-flex">
						<div className="fs-16 fw-600 mx-2 text-capitalize">
							{trans("geofences")}
						</div>
						<div className="object-details-head object-head-first">
							{Geofences?.length ? Geofences?.length : 0}
							<span className=""> {trans("Total")}</span>
						</div>
					</div>
				)}
				<img
					src={`${process.env.PUBLIC_URL}/assets/Double-arrow.svg`}
					style={{ transform: lang !== "en" ? "rotate(-180deg)" : "" }}
					alt="Doublearrow"
					role="button"
					onClick={handleClick}
				/>{" "}
			</div>
		</>
	);
}
